<template>
  <component
    :is="tag"
    v-on="$listeners"
    class="chat-contact-item"
  >
    <B-Avatar
      size="42"
      :badge="user.unread_count.toString()"
      v-if="user.unread_count > 0"
      class="mr-1"
      variant="light-secondary"
      badge-variant="danger"
    />
        <B-Avatar
      size="42"
      v-if="user.unread_count == 0"
      class="mr-1"
      variant="light-secondary"
    />
    <div class="chat-info flex-grow-1">
      <h5 class="mb-0">
        {{ user.display_name }}
      </h5>

      <div v-if="user.message_type == 'text'">
        <p class="card-text text-truncate">
          {{ user.message.slice(0, 20) }}
        </p>
      </div>

      <div v-else-if="user.message_type == 'image'">
        <feather-icon
            icon="CameraIcon"
            size="24"
        />
      </div>

      <div v-else-if="user.message_type == 'sticker'">
        <p class="card-text text-truncate">
          sticker
        </p>
      </div>

      <div v-else-if="user.message_type == 'audio'">
        <feather-icon
            icon="Volume2Icon"
            size="24"
        />
      </div>

      <div v-else-if="user.message_type == 'video'">
        <feather-icon
            icon="VideoIcon"
            size="24"
        />
      </div>

      <div v-else-if="user.message_type == 'document'">
        <feather-icon
            icon="PaperclipIcon"
            size="24"
        />
      </div>

      <div v-else>
        <p class="card-text text-truncate">
          other message type
        </p>
      </div>

      
    </div>
    <div
      v-if="isChatContact"
      class="chat-meta text-nowrap"
    >
      <small class="float-right mb-25 chat-time">{{ formatDate(user.last_time) }}</small>
    </div>  
    <hr class="chat-divider" />
  </component>
</template>

<style scoped>
.chat-contact-item{
  border-bottom: 1px solid #e5e5e5;
}

.chat-divider {
  margin: 0.4rem 0 0;
  border: none;
  border-top: 1px solid #eee;
}
</style>

<script>
import { BAvatar, BBadge } from 'bootstrap-vue'
//import { formatDateToMonthShort } from '@core/utils/filter'
import useChat from './useChat'

export default {
  components: {
    BAvatar,
    BBadge,
  },
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    user: {
      type: Object,
      required: true,
    },
    isChatContact: {
      type: Boolean,
      dedfault: false,
    },
  },
  setup() {
    const { resolveAvatarBadgeVariant } = useChat()
    function formatDate(delivery_datetime){
      const date = new Date(delivery_datetime);
      date.setHours(date.getHours() - 8);
      const now = new Date();
      const inputMidnight = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      const nowMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const diffInDays = Math.floor((nowMidnight - inputMidnight) / (1000 * 60 * 60 * 24));
      if (diffInDays === 0) return date.toTimeString().slice(0, 5);
      if (diffInDays === 1) return 'Yesterday';
      if (diffInDays === 2) return '2 days ago';
      return date.toISOString().split('T')[0];
    }
    return { formatDate,resolveAvatarBadgeVariant }
  },
}
</script>

<style>

</style>
